export const SUBJECT_DETAILS_API_ROUTES = {
   DETAILS: 'testPage',
   STANDARD_CLASSES :'standardClasses',
   STANDARD_CLASSES_LIST : 'standardClassList',
   POPULAR_TEST:'popularTest',
   RECOMMENDED_TEST:'recommendedTest'
}